import React from 'react';
import HomeCard from "./HomeCard";

const HomeHelpContent = () => {
    return (
        <HomeCard>
            <h3 className="text-2xl font-semibold mb-6">Help & Support</h3>
            {/* Add FAQs and support information here */}
        </HomeCard>
    );
};

export default HomeHelpContent;
